import { ClientProxy } from '../../base/proxy/clientProxy'
import { GetSerialNumberCheck } from '../../pages/MySpecial/MyOrders/models/request/getMyOrderRequest'
import { GetSerialNumberCheckResponse } from '../../pages/MySpecial/MyOrders/models/response/getOrderListResponseModel'
import { GetMyOrdersApi } from '../../pages/MySpecial/MyOrders/services/getMyOrdersApi'
import { normalizeOrder } from './chatMappers'
import { ChatOrder } from './types'

function normalizeIdentifier(value?: string | null): string | null {
  const normalized = value?.trim()
  return normalized && normalized !== '-' ? normalized : null
}

type GetMyOrdersLoader = (orderNumber: string, dealerCode: string) => Promise<unknown[]>

async function loadOrderByNumber(orderNumber: string, dealerCode: string): Promise<unknown[]> {
  return await new GetMyOrdersApi({}).getMyOrders({
    CompanyCode: [],
    OrderDocNO: orderNumber,
    DealerCode: dealerCode,
    StartDate: '',
    EndDate: '',
  })
}

/**
 * Sipariş satırındaki GetMyOrders alanlarını seri numarası servisinin beklediği
 * sözleşmeye çevirir. Eksik tanımlayıcıyla geniş kapsamlı sorgu yapılmasını önler.
 */
export function buildOrderSerialNumberRequest(order: ChatOrder, dealerCode = ''): GetSerialNumberCheck | null {
  const companyCode = normalizeIdentifier(order.companyCode)
  const invoiceNumber = normalizeIdentifier(order.invoiceNumber)
  const eInvoiceNumber = normalizeIdentifier(order.eInvoiceNumber)
  const allInvoiceNumber = eInvoiceNumber || invoiceNumber

  if (!companyCode || !allInvoiceNumber) return null

  return {
    CompanyCode: companyCode,
    DealerCode: dealerCode.trim(),
    SerialNumber: '',
    InvoiceNumber: '',
    EInvoiceNumber: '',
    AllInvoiceNumber: allInvoiceNumber,
  }
}

/**
 * Chat yanıtı CompanyCode alanını taşımadığında siparişin gerçek GetMyOrders
 * satırını yükleyerek seri no request'ini kaynak veriden tamamlar.
 */
export async function resolveOrderSerialNumberRequest(
  order: ChatOrder,
  dealerCode = '',
  loadOrders: GetMyOrdersLoader = loadOrderByNumber
): Promise<GetSerialNumberCheck | null> {
  const currentRequest = buildOrderSerialNumberRequest(order, dealerCode)
  if (currentRequest) return currentRequest

  const orders = await loadOrders(order.orderNumber, dealerCode.trim())

  const normalizedOrderNumber = order.orderNumber.trim()
  const matchingOrder =
    orders.find(item => normalizeOrder(item).orderNumber.trim() === normalizedOrderNumber) ?? orders[0]
  if (!matchingOrder) return null

  return buildOrderSerialNumberRequest(normalizeOrder(matchingOrder), dealerCode)
}

export class OrderSerialNumberApi extends ClientProxy {
  constructor() {
    super({ url: 'MyReports/GetSerialNumberCheck' })
  }

  public async list(request: GetSerialNumberCheck): Promise<GetSerialNumberCheckResponse[]> {
    return await this.postAsync<GetSerialNumberCheckResponse[]>(request)
  }
}
